import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import Select from "react-select";
import Alert from "../../../Common/Alert";
import DatatableFunc from "../../../Common/DatatableFunc";
import Http from "../../../Common/Http";
import Swal from "sweetalert2";
import IsLogin from "../../../Common/IsLogin";
import { LoaderComponent } from "../../../Common/LoaderComponent";

const HandiPosSalesReport = () => {
  const location = useLocation();
  const [receiveData, setReceiveData] = useState([]);
  const [kitchenStaff, setKitchenStaff] = useState([]);
  const [loading, setLoading] = useState(false);
  const [expandedKitchens, setExpandedKitchens] = useState({});
  const [reportData, setReportData] = useState({
    total_kitchens: 0,
    total_counters: 0,
    total_orders: 0,
    total_pos_sales: 0,
    data: []
  });

  // Utility functions to get current month date range
  const getCurrentMonthRange = () => {
    const now = new Date();
    const year = now.getFullYear();
    const month = now.getMonth();

    // First day of current month
    const firstDay = new Date(year, month, 1);
    // Last day of current month
    const lastDay = new Date(year, month + 1, 0);

    return {
      start_date: firstDay.toISOString().split('T')[0], // Format: YYYY-MM-DD
      end_date: lastDay.toISOString().split('T')[0]     // Format: YYYY-MM-DD
    };
  };

  const [inputs, setInputs] = useState(() => {
    const currentMonthRange = getCurrentMonthRange();
    return {
      start_date: currentMonthRange.start_date,
      end_date: currentMonthRange.end_date,
      kitchen_staff_id: "",
    };
  });
  const [alert, setAlert] = useState(null);

  const fetchData = () => {
    setLoading(true);
    const params = new URLSearchParams();

    if (inputs.start_date) params.append('start_date', inputs.start_date);
    if (inputs.end_date) params.append('end_date', inputs.end_date);
    if (inputs.kitchen_staff_id && inputs.kitchen_staff_id !== "") params.append('kitchen_staff_id', inputs.kitchen_staff_id);

    console.log("Fetching Handi POS Sales data with params:", params.toString());

    Http.get(`/report-handi-pos-sales?${params.toString()}`).then((res) => {
      setReportData({
        total_kitchens: res.data.total_kitchens || 0,
        total_counters: res.data.total_counters || 0,
        total_orders: res.data.total_orders || 0,
        total_pos_sales: res.data.total_pos_sales || 0,
        data: res.data.data || []
      });
      setLoading(false);
    }).catch((error) => {
      console.error("Error fetching Handi POS Sales data:", error);
      setLoading(false);
      showAlert("Error fetching Handi POS Sales data", "error");
    });
  };

  useEffect(() => {
    const fetchInitialData = async () => {
      try {
        const kitchenLists = await Http.get(
          "/staff2?user_type=kitchen",
        );
        setKitchenStaff(kitchenLists.data);
        DatatableFunc();
        fetchData();
      } catch (error) {
        console.error("Error fetching initial data:", error);
        DatatableFunc();
        fetchData();
      }
    };

    fetchInitialData();
  }, []);

  // Auto-fetch data when filters change (with debounce)
  useEffect(() => {
    const timeoutId = setTimeout(() => {
      if (inputs.start_date || inputs.end_date || inputs.kitchen_staff_id) {
        fetchData();
      }
    }, 500);

    return () => clearTimeout(timeoutId);
  }, [inputs.start_date, inputs.end_date, inputs.kitchen_staff_id]);

  // Check for month change every hour and update date range if needed
  useEffect(() => {
    const checkMonthChange = () => {
      const currentMonthRange = getCurrentMonthRange();
      if (inputs.start_date !== currentMonthRange.start_date ||
          inputs.end_date !== currentMonthRange.end_date) {
        // Only update if the current dates match a previous month's range
        const currentDate = new Date();
        const inputStartDate = new Date(inputs.start_date);
        const inputEndDate = new Date(inputs.end_date);

        // Check if the current input dates represent a full month range
        const isFullMonthRange = inputStartDate.getDate() === 1 &&
                                inputEndDate.getDate() === new Date(inputEndDate.getFullYear(), inputEndDate.getMonth() + 1, 0).getDate();

        if (isFullMonthRange && inputStartDate.getMonth() !== currentDate.getMonth()) {
          console.log("Month changed, updating date range to current month");
          refreshCurrentMonth();
        }
      }
    };

    // Check immediately and then every hour
    checkMonthChange();
    const interval = setInterval(checkMonthChange, 60 * 60 * 1000); // Check every hour

    return () => clearInterval(interval);
  }, [inputs.start_date, inputs.end_date]);

  const showAlert = (message, type) => {
    setAlert({
      message: message,
      type: type,
    });
    setTimeout(() => {
      setAlert(null);
    }, 4000);
  };

  useEffect(() => {
    if (!location.state) {
      return;
    }
    showAlert(location.state.message, location.state.type);
  }, [location]);

  const selectHandleChange = (selectedOption, actionMeta) => {
    const name = actionMeta.name;
    const value = selectedOption ? selectedOption.value : "";
    console.log("Select change:", name, value, selectedOption);
    setInputs((values) => ({ ...values, [name]: value }));
  };

  const handleChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    setInputs((values) => ({ ...values, [name]: value }));
  };

  const formSubmit = () => {
    fetchData();
  };

  const clearFilters = () => {
    const currentMonthRange = getCurrentMonthRange();
    setInputs({
      start_date: currentMonthRange.start_date,
      end_date: currentMonthRange.end_date,
      kitchen_staff_id: "",
    });
    setTimeout(() => {
      fetchData();
    }, 100);
  };

  const refreshCurrentMonth = () => {
    const currentMonthRange = getCurrentMonthRange();
    setInputs(prevInputs => ({
      ...prevInputs,
      start_date: currentMonthRange.start_date,
      end_date: currentMonthRange.end_date,
    }));
  };

  const toggleKitchenExpand = (kitchenId) => {
    setExpandedKitchens(prev => ({
      ...prev,
      [kitchenId]: !prev[kitchenId]
    }));
  };



  return (
    <div>
      <IsLogin></IsLogin>
      <LoaderComponent />
      <div>
        <div className="am-mainpanel">
          <div className="am-pagetitle">
            <h5 className="am-title">Handi Receive vs POS Sales Report</h5>
          </div>
          <div className="am-pagebody">
            <Alert alert={alert} />
            <div className="card pd-sm-40">
              <div className="row">
                <div className="col-lg-3">
                  <label className="form-label">Start Date</label>
                  <input
                    type="date"
                    className="form-control"
                    name="start_date"
                    value={inputs.start_date || ""}
                    onChange={handleChange}
                  />
                </div>
                <div className="col-lg-3">
                  <label className="form-label">End Date</label>
                  <input
                    type="date"
                    className="form-control"
                    name="end_date"
                    value={inputs.end_date || ""}
                    onChange={handleChange}
                  />
                </div>
                <div className="col-lg-3">
                  <label htmlFor="">
                    Kitchen Staff
                  </label>
                  <Select
                    className="basic-single"
                    classNamePrefix="select"
                    name="kitchen_staff_id"
                    options={kitchenStaff}
                    onChange={selectHandleChange}
                    isClearable={true}
                  />
                </div>
                <div className="col-lg-3">
                  <label className="form-label">&nbsp;</label>
                  <div className="d-flex gap-2">
                    <button
                      className="btn btn-primary btn-block"
                      onClick={formSubmit}
                      disabled={loading}
                    >
                      <i className="fa fa-search mg-r-10"></i>
                      {loading ? "Searching..." : "Search"}
                    </button>
                  </div>
                </div>
              </div>
              <div className="row mt-3">
                <div className="col-lg-6">
                  <button
                    className="btn btn-info btn-block mg-b-10"
                    onClick={refreshCurrentMonth}
                    title="Set date range to current month"
                  >
                    <i className="fa fa-calendar mg-r-10"></i> Current Month
                  </button>
                </div>
                <div className="col-lg-6">
                  <button
                    className="btn btn-secondary btn-block mg-b-10"
                    onClick={clearFilters}
                    title="Reset all filters to current month defaults"
                  >
                    <i className="fa fa-refresh mg-r-10"></i> Reset Filters
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="am-pagebody">
            <div className="card pd-20 pd-sm-40">
              <div className="row mb-4">
                <div className="col-lg-3">
                  <div className="card bg-primary text-white">
                    <div className="card-body">
                      <div className="d-flex justify-content-between">
                        <div>
                          <h6>Total Kitchens</h6>
                          <h3>{reportData.total_kitchens}</h3>
                        </div>
                        <i className="fa fa-utensils fa-3x opacity-50"></i>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-3">
                  <div className="card bg-success text-white">
                    <div className="card-body">
                      <div className="d-flex justify-content-between">
                        <div>
                          <h6>Total Counters</h6>
                          <h3>{reportData.total_counters}</h3>
                        </div>
                        <i className="fa fa-cash-register fa-3x opacity-50"></i>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-3">
                  <div className="card bg-info text-white">
                    <div className="card-body">
                      <div className="d-flex justify-content-between">
                        <div>
                          <h6>Total Orders</h6>
                          <h3>{reportData.total_orders}</h3>
                        </div>
                        <i className="fa fa-shopping-cart fa-3x opacity-50"></i>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-3">
                  <div className="card bg-warning text-white">
                    <div className="card-body">
                      <div className="d-flex justify-content-between">
                        <div>
                          <h6>Total POS Sales</h6>
                          <h3>{parseFloat(reportData.total_pos_sales || 0).toFixed(2)}</h3>
                        </div>
                        <i className="fa fa-money fa-3x opacity-50"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="table-responsive p-0 pb-2">
                  <table className="table table-sm table-bordered table-striped align-items-center justify-content-center mb-0">
                    <thead className="thead-dark">
                      <tr>
                        <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2" style={{width: '40px'}}></th>
                        <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2">Kitchen Name</th>
                        <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2 text-center">Kitchen Order Count</th>
                        <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2 text-end">Kitchen POS Sales</th>
                      </tr>
                    </thead>
                    <tbody>
                      {reportData.data && reportData.data.length > 0 ? (
                        reportData.data.map((kitchen) => (
                          <React.Fragment key={kitchen.kitchen_id}>
                            <tr style={{ cursor: 'pointer' }} onClick={() => toggleKitchenExpand(kitchen.kitchen_id)}>
                              <td className="text-center">
                                <i className={`fa ${expandedKitchens[kitchen.kitchen_id] ? 'fa-minus-square' : 'fa-plus-square'} text-primary`}></i>
                              </td>
                              <td className="text-xs">
                                <b>{kitchen.kitchen_name}</b>
                              </td>
                              <td className="text-xs text-center">
                                <b>{kitchen.kitchen_order_count || 0}</b>
                              </td>
                              <td className="text-xs text-end">
                                <b>{parseFloat(kitchen.kitchen_pos_sales_total || 0).toFixed(2)}</b>
                              </td>
                            </tr>
                            {expandedKitchens[kitchen.kitchen_id] && kitchen.report_counters && (
                              kitchen.report_counters.map((counter) => (
                                <tr key={counter.counter_id} className="bg-light">
                                  <td></td>
                                  <td className="text-xs ps-4">
                                    {counter.counter_name}
                                    {counter.counter_email && (
                                      <div className="text-muted small">{counter.counter_email}</div>
                                    )}
                                  </td>
                                  <td className="text-xs text-center">
                                    {counter.order_count || 0}
                                  </td>
                                  <td className="text-xs text-end">
                                    {parseFloat(counter.pos_sales_total || 0).toFixed(2)}
                                  </td>
                                </tr>
                              ))
                            )}
                          </React.Fragment>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="4" className="text-center py-4">
                            No data available
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HandiPosSalesReport;